export const classes = {
  wrapper: 'flex items-center gap-3',
  toothDesign: 'w-48', // 12rem
  archShape: 'w-32', // 6rem
  sliderWrapper: 'mx-4 px-2 flex flex-col justify-center text-center',
  archWrapper: 'w-[200px]',
  compareWrapper: 'w-[150px]',
  slider: 'w-full mx-0 py-0 mb-2',
  sliderLabel:
    'text-xs font-semibold text-grey-7 dark:text-mauve-2 tracking-wide',
  toggleBlock: 'border-none',
  toggleLabel: 'ml-2',
};
